import React from "react";
import { EmptyModal, Gallery } from "../../../../components/core";
import { Dialog } from "primereact/dialog";

export default function ViewSubmitIdModal({
	open,
	onClose,
	ids = [],
	className,
	images = [],
}) {
	const [currentImageSrc, setCurrentSrc] = React.useState("");
	const [currentIndex, setCurrentIndex] = React.useState(0);
	React.useEffect(() => {
		if (ids.length > 0) {
			setCurrentSrc(ids[currentIndex]);
		}
	}, [currentIndex]);
	const handleNextPicture = () => {
		if (currentIndex < ids.length - 1) {
			let tempIndex = currentIndex;
			tempIndex++;
			setCurrentIndex(tempIndex);
		} else {
			setCurrentIndex(0);
		}
	};
	const handlePrevPicture = () => {
		if (currentIndex > 0) {
			let tempIndex = currentIndex;
			tempIndex--;
			setCurrentIndex(tempIndex);
		} else {
			setCurrentIndex(ids.length - 1);
		}
	};
	const handleJumpToPicture = (event) => {
		setCurrentIndex(parseInt(event.target.id));
	};
	return (
		<EmptyModal
			open={open}
			width={"70vh"}
			height={"auto"}
			className={`z-[99999999999999999]`}
		>
			<i className={"fas fa-close text-end cursor-pointer"} onClick={onClose} />
			<Gallery images={images} />
			{/* <
			<p className="text-center">
				{currentIndex + 1} of {ids.length}
			</p>
			<div className="flex gap-2">
				<i
					onClick={handlePrevPicture}
					className="cursor-pointer fas fa-arrow-left my-auto border-stone-400 border-2 p-2 rounded-full hover:bg-primary-primaryYellowLight hover:text-white hover:border-yellow-500"
				></i>
				<img
					src={currentImageSrc}
					className="w-full border-8 border-stone-400 cursor-pointer"
				></img>
				<i
					onClick={handleNextPicture}
					className="cursor-pointer fas fa-arrow-right my-auto border-stone-400 border-2 p-2 rounded-full hover:bg-primary-primaryYellowLight hover:text-white hover:border-yellow-500"
				></i>
			</div>
			<div className="mt-10 flex gap-4 justify-center">
				{ids.map((data, index) => {
					if (currentIndex === index) {
						return (
							<img
								onClick={handleJumpToPicture}
								key={index}
								id={index}
								src={ids[index]}
								className="border-2 border-stone-500 h-11 cursor-pointer"
							/>
						);
					}
					return (
						<img
							onClick={handleJumpToPicture}
							key={index}
							id={index}
							src={ids[index]}
							className="border-2 border-stone-500 bg-black h-11 cursor-pointer opacity-40"
						/>
					);
				})}
			</div> */}
		</EmptyModal>

		// <Dialog className="z-[999999999999999999999999]" open={open}></Dialog>
	);
}
